var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.240234,
    y: 0.813965,
    width: 41.6947,
    height: 41.6947,
    rx: 11.8004,
    fill: "#FFF4D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2676 17.1572C11.2676 15.7145 12.4371 14.5449 13.8799 14.5449H28.2926C29.7353 14.5449 30.9049 15.7145 30.9049 17.1572V18.9588V26.1652C30.9049 27.6079 29.7353 28.7775 28.2926 28.7775H13.8799C12.4372 28.7775 11.2676 27.6079 11.2676 26.1652V18.9588V17.1572ZM13.8799 16.1664C13.3326 16.1664 12.889 16.61 12.889 17.1572V18.1481H29.2835V17.1572C29.2835 16.61 28.8398 16.1664 28.2926 16.1664H13.8799ZM29.2835 19.7695H12.889V26.1652C12.889 26.7124 13.3326 27.156 13.8799 27.156H28.2926C28.8398 27.156 29.2835 26.7124 29.2835 26.1652V19.7695ZM22.0771 24.3636C22.0771 23.9158 22.4401 23.5529 22.8878 23.5529H26.491C26.9388 23.5529 27.3017 23.9158 27.3017 24.3636C27.3017 24.8113 26.9388 25.1743 26.491 25.1743H22.8878C22.4401 25.1743 22.0771 24.8113 22.0771 24.3636Z",
    fill: "#F9B810"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.4b0713bc963f4de339fb5515c8a915d5.svg";
export { ForwardRef as ReactComponent };